// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.instrument-copy {
  color: var(--secondary);
  margin: 0 0 1rem;
}

.status-form {
  display: grid;
  gap: 0.35rem;
  min-width: 0;
}

.form-error {
  color: var(--danger);
  font-size: 0.85rem;
  margin-bottom: 0.75rem;
}

mat-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-equipment/instrument-status-dialog.component.scss"],"names":[],"mappings":"AAAA;EAAmB,uBAAA;EAAyB,gBAAA;AAG5C;;AAFA;EAAe,aAAA;EAAe,YAAA;EAAa,YAAA;AAQ3C;;AAPA;EAAc,oBAAA;EAAsB,kBAAA;EAAmB,sBAAA;AAavD;;AAZA;EAAiB,WAAA;AAgBjB","sourcesContent":[".instrument-copy { color: var(--secondary); margin: 0 0 1rem; }\n.status-form { display: grid; gap: .35rem; min-width: 0; }\n.form-error { color: var(--danger); font-size: .85rem; margin-bottom: .75rem; }\nmat-form-field { width: 100%; }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
